/// <reference path="../../../typings/tsd.d.ts" /> 
/// <reference path="../../../typings/linq/linq.d.ts" />
module warsApp.models {

    declare var contentPagesModelSelf: ContentPagesModel;

    export class ContentPageDto {
        Id: string;
        Title: string;
        IsEditable: boolean;
        Html: string;
        FriendlyName: string;
        SecurityMatrixId: string;
        EditSecurityMatrixId: string;
    }

    export class ContentPagesModel {

        public pages: Wars.Domain.Model.Dtos.ContentPageDto[];
        public selectedPage: Wars.Domain.Model.Dtos.ContentPageDto;
        public linkPage: Wars.Domain.Model.Dtos.ContentPageDto;
        public viewSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        public editSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        public activeProcessTypes: Wars.Domain.Model.ProcessType[];
        public processConfigurationId: string;
        public tinyMce: any;
        private modalService: any;
        public documentList: any;
        public staticDocuments: Array<Wars.Domain.Model.StaticDocument>;
        public tinyMceOptions: any;

        constructor(
            private contentPageService: warsApp.services.ContentPageService,
            private securityMatrixService: warsApp.services.SecurityMatrixService,
            private processTypeService: services.ProcessTypeService,
            private systemLevelService: services.SystemLevelService,
            modalService: any) {

            contentPagesModelSelf = this;
            contentPagesModelSelf.modalService = modalService;
            contentPagesModelSelf.processConfigurationId = undefined;

            contentPagesModelSelf.contentPageService.getContentPagesForConfiguration()
                .then(pages => {
                    contentPagesModelSelf.pages = pages;
                });

            contentPagesModelSelf.processTypeService.getActiveProcessTypes()
                .then(result => {
                    contentPagesModelSelf.activeProcessTypes = result;
                });

            contentPagesModelSelf.systemLevelService.getSystemLevelStaticDocuments()
                .then(systemLevel => {
                    contentPagesModelSelf.staticDocuments = systemLevel.myStaticDocuments;
                    contentPagesModelSelf.documentList = [];
                    contentPagesModelSelf.staticDocuments.forEach(document => {
                        contentPagesModelSelf.documentList
                            .push({ title: document.name, value: 'api/Document/StaticDocument/' + document.id });
                    });

                    contentPagesModelSelf.tinyMceOptions = {
                        format: 'raw',
                        entity_encoding: 'raw',
                        menubar: false,
                        height: 600,
                        plugins: "link image imagetools preview code",
                        imagetools_toolbar: "rotateleft rotateright | flipv fliph | editimage imageoptions",
                        content_css: "content/mce.css",
                        toolbar1:
                            'addlink | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | image | preview | code',
                        link_list: contentPagesModelSelf.documentList,
                        image_list: contentPagesModelSelf.documentList, //TODO - Kevin do i need this?
                        setup(editor) {
                            editor.addButton('addlink',
                            {
                                text: 'Link to Page',
                                type: 'menubutton',
                                icon: false,
                                menu: [
                                    {
                                        text: 'Link to Static Page',
                                        onclick() {
                                            contentPagesModelSelf.modalService.showModal({
                                                templateUrl: "./app/views/modals/contentPageStaticLinkModal.html",
                                                controller: "contentPageStaticLinkModalController",
                                                inputs: {
                                                    contentPages: contentPagesModelSelf.pages
                                                }
                                            }).then(modal => {
                                                // The modal object has the element built, if this is a bootstrap modal
                                                // you can call 'modal' to show it, if it's a custom modal just show or hide
                                                // it as you need to.                
                                                modal.element.modal();
                                                modal.close.then(result => {
                                                    if (result) {
                                                        editor
                                                            .insertContent('<a href="./#/ContentPage/' + result.id + '">Link to ' + result.title + '</a>');
                                                    }
                                                });
                                            });
                                        }
                                    },
                                    {
                                        text: 'Link to Process',
                                        onclick() {
                                            contentPagesModelSelf.modalService.showModal({
                                                templateUrl: "./app/views/modals/contentPageProcessLinkModal.html",
                                                controller: "contentPageProcessLinkModalController",
                                                inputs: {
                                                    activeProcessTypes: contentPagesModelSelf.activeProcessTypes
                                                }
                                            }).then(modal => {
                                                // The modal object has the element built, if this is a bootstrap modal
                                                // you can call 'modal' to show it, if it's a custom modal just show or hide
                                                // it as you need to.                
                                                modal.element.modal();
                                                modal.close.then(result => {
                                                    if (result) {
                                                        editor.insertContent('<a href="./#/ProcessType/' + result.id + '/Process">Link to ' + result.name + '</a>');
                                                    }
                                                });
                                            });
                                        }
                                    }
                                ]
                            });
                        }
                    }
                });
        }

        public selectPage(page: Wars.Domain.Model.Dtos.ContentPageDto) {
            contentPagesModelSelf.securityMatrixService.fetchById(page.securityMatrixId, "SecurityMatrix")
                .then((securityMatrix) => {
                    contentPagesModelSelf.viewSecurityMatrix = securityMatrix;
                    contentPagesModelSelf.securityMatrixService.fetchById(page.editSecurityMatrixId, "SecurityMatrix")
                        .then((editSecurityMatrix) => {
                            contentPagesModelSelf.editSecurityMatrix = editSecurityMatrix;
                            contentPagesModelSelf.selectedPage = page;
                        });
                });
        }

        public addPage() {
            contentPagesModelSelf.viewSecurityMatrix = contentPagesModelSelf.securityMatrixService.createSecurityRow(true);
            contentPagesModelSelf.editSecurityMatrix = contentPagesModelSelf.securityMatrixService.createSecurityRow(true);
            var contentPageDto = new ContentPageDto();
            contentPageDto.Title = "New Content Page";
            contentPageDto.FriendlyName = "";
            contentPageDto.SecurityMatrixId = contentPagesModelSelf.viewSecurityMatrix.id;
            contentPageDto.EditSecurityMatrixId = contentPagesModelSelf.editSecurityMatrix.id;

            contentPagesModelSelf.securityMatrixService.saveAllChanges(() => {
                contentPagesModelSelf.contentPageService.addContentPage(contentPageDto)
                    .then((contentPage) => {
                        contentPagesModelSelf.pages.push(contentPage);
                        contentPagesModelSelf.selectPage(contentPage);
                    });
            });
        }

        public updateContentPage() {
            contentPagesModelSelf.contentPageService.updateContentPage(contentPagesModelSelf.selectedPage);
        }

        public openViewSecurityMatrixModal() {
            contentPagesModelSelf.securityMatrixService.openSecurityMatrixModal(contentPagesModelSelf.viewSecurityMatrix, undefined);
        }

        public openEditSecurityMatrixModal() {
            contentPagesModelSelf.securityMatrixService.openSecurityMatrixModal(contentPagesModelSelf.editSecurityMatrix, undefined);
        }
    }
}